import {API} from "./API";
import {Contract} from "../models/Contract";

export class ContractsAPI extends API<Contract> {

	constructor () {
		super("contracts");
	}

}
